export const SHOW_CHAT_BOT = 'publicWeb/chatBot/transition/showChatBot';
export const HIDE_CHAT_BOT = 'publicWeb/chatBot/transition/hideChatBot';

export const showChatBot = () => ({ type: SHOW_CHAT_BOT });
export const hideChatBot = () => ({ type: HIDE_CHAT_BOT });
